import { useState, useEffect } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { forwardRef } from 'react';

const Select = forwardRef(({defaultValue, displayEmpty, ...props}, ref) => {
  const [ value, setValue ] = useState(getSelectedValue());
  
  const ITEM_HEIGHT = 36;
  const ITEM_PADDING_TOP = 8;

  function getSelectedValue(){
    return props.options.find(el => el.value === (props.value ?? defaultValue))?.value ?? ''
  };

  const handleChange = (event) => {
    setValue(event.target.value);

    if (typeof props.onChange !== 'undefined'){
      props.onChange(event);
    }
  };

  useEffect(() => {
    setValue(getSelectedValue());
  },[props.options, props.value]);

  return(
    <TextField
      ref={ref}
      select
      size='small'
      fullWidth
      {...props}
      value={value}
      onChange={handleChange}
      SelectProps={{
        displayEmpty: displayEmpty,
        MenuProps: {
          sx: { height: ITEM_HEIGHT * 8 + ITEM_PADDING_TOP },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          }
        }
      }}
    >
      {props.children}
      {props.options.map((option, i) =>
        <MenuItem key={i} value={option.value} disabled={option.disabled}>{option.label}</MenuItem>
      )}
    </TextField>
  )
});
export default Select;